import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import Cookies from 'js-cookie';
import { fetchUser } from '../features/auth/userSlice';
import Loading from '../components/ui/Loading';

const ProtectedRoute = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, loading } = useSelector((state: RootState) => state.user); 
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      if (!user) {
        const userId = Cookies.get('userId');
        if (userId) {
          await dispatch(fetchUser(userId));
        }
      }
      setChecking(false);
    };
    checkUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (checking || loading) {
    return <Loading/>;
  }

  const isAuthenticated = user?.role?.toLowerCase().trim() === "admin";

  return isAuthenticated ? (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
